import { render, staticRenderFns } from "./miniFooter.vue?vue&type=template&id=2d462293&scoped=true&"
import script from "./miniFooter.vue?vue&type=script&lang=js&"
export * from "./miniFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d462293",
  null
  
)

export default component.exports